import React, { useEffect, useState } from "react";
import styles from "./ChangePlatformClinic.module.scss";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../miscellaneous/Modal/Modal";

import { $t } from "../../../helpers/translator";
import MultiSelect from "../../miscellaneous/MultiSelect/MultiSelect";
import { getClinics } from "../../../store/data-slice";
import _ from "lodash";
import api from "../../../helpers/api";
import { setAlert } from "../../../store/alerts-slice";
import Loader from "../../miscellaneous/Loader/Loader";
import HasPermission from "helpers/permissions/HasPermission";
import { getUser } from "../../../store/auth-slice";

const ChangePlatformClinic = (props) => {
  const dispatch = useDispatch();

  const [clinicOptions, setClinicOptions] = useState(null);
  const [clinicOptionsSelected, setClinicOptionsSelected] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalDetach, setShowModalDetach] = useState(false);
  const [showDetachModalConfirmationBox, setShowDetachModalConfirmationBox] =
    useState(false);

  useEffect(() => {
    (async function () {
      await getClinicOptions();
    })();
  }, [props.platform]);

  async function getClinicOptions() {
    let res = await dispatch(getClinics());
    let clinics = [...res];

    if (!props.platform) {
      return;
    }

    clinics = _.remove(clinics, function (n) {
      return !n.is_chain;
    });

    let userData = await dispatch(getUser());
    // console.log('USERR1', userData.permissions)
    var deletionPermission =
      userData.permissions.indexOf("platform:delete") !== -1 ? true : false;
    // console.log("USERR1", deletionPermission, userData.permissions);

    if (props.userType && props.userType === 5 && deletionPermission) {
      //allow detach
      let noClinic = {
        id: null,
        label: $t("global.machines.detached"),
        value: null,
      };
      clinics.unshift(noClinic);
    }

    let clinicIndex = _.findIndex(clinics, function (o) {
      return o.id === props.platform.clinic_id;
    });

    if (clinicIndex >= 0) {
      setClinicOptionsSelected(clinics[clinicIndex]);
    }

    setClinicOptions(clinics);


  }

  async function formSentClickHandler() {
    console.log('clinicOptionsSelected', clinicOptionsSelected, typeof clinicOptionsSelected)

    if (!clinicOptionsSelected || !clinicOptionsSelected.hasOwnProperty('id')) {
        console.log('abort')
        return;
    }
    

    try {
      let res = null;

      if (clinicOptionsSelected.id) {
        res = await api.patch(`/platform/${props.platform.id}`, {
          clinic_id: clinicOptionsSelected.id,
        });
      } else {
        res = await api.post(`/platform/${props.platform.id}/detach`);
      }

      if (res && res.success) {
        dispatch(setAlert({ type: "success" }));
        setShowModal(false);
        props.onClose();
        return;
      }
      dispatch(setAlert({ type: "error" }));
    } catch (e) {
      console.error(e);
      dispatch(setAlert({ type: "error" }));
    } finally {
      props.onChange();
    }
  }

  async function formSentDistributorHandler() {
    try {
      let res = null;

      res = await api.post(`/platform/${props.platform.id}/detach/distributor`);

      if (res && res.success) {
        dispatch(setAlert({ type: "success" }));
        setShowModal(false);
        props.onClose();
        return;
      }
      dispatch(setAlert({ type: "error" }));
    } catch (e) {
      console.error(e);
      dispatch(setAlert({ type: "error" }));
    } finally {
      props.onChange();
    }
  }

  function renderModalContent() {
    return (
      <div>
        <div className={"alma-box-header"}>
          <div>
            <h3>{$t("global.machines.transferPlatformToClinic")}</h3>
          </div>
        </div>
        <div className={"alma-box-content"}>
          <div className={"alma-field-container"}>
            <div className={"alma-field-header"}>
              {$t("global.staff.clinic")}
            </div>
            {clinicOptions ? (
              <MultiSelect
                // tooltip={props.mode === 'edit' ? $t('global.staff.cannotChangeStaffClinic') : null}
                // disabled={props.mode === 'edit'}
                searchable
                options={clinicOptions}
                selected={clinicOptionsSelected}
                onValueChange={(data) => {
                  setClinicOptionsSelected(data);
                  // console.log(clinicOptionsSelected)
                }}
              />
            ) : (
              <Loader />
            )}
          </div>
        </div>
        <div className={"alma-box-footer"}>
          <div />
          {clinicOptionsSelected && clinicOptionsSelected.id === null ? (
            <div>
              <div
                className={"alma-danger-button"}
                onClick={() => formSentClickHandler()}
              >
                {$t("global.machines.detach")}
              </div>
              <div className={styles["red-danger"]}>
                {$t("global.machines.platformWillBeDetachedWarning")}
              </div>
            </div>
          ) : (
            <div
              className={"alma-button"}
              onClick={() => formSentClickHandler()}
            >
              {$t("global.machines.save")}
            </div>
          )}
        </div>
      </div>
    );
  }

  function renderModalDetachContent() {
    return (
      <div >
        <div className={"alma-box-header"}>
          <div>
            <h3>{$t("global.machines.detachfromdistributor")}</h3>
          </div>
        </div>
        <div className={"alma-box-content"}>
          <div className={styles["detach-contaner"]}>
            <div className={styles["detach-content"]}>
              After detaching platform from distributor, it will be available only for Admin.
              Are you shure you want to detach this platform from distributor?
            </div>
          </div>
        </div>
        <div className={"alma-box-footer"}>
          <div />
          <div
              className={"alma-button"}
              onClick={() => formSentDistributorHandler()}
            >
              {$t("global.machines.detach")}
            </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles["container"]}`}>
      <div className={styles.flexRow}>
        <div className={"alma-button"} onClick={() => setShowModal(true)}>
          {$t("global.machines.transferPlatformToClinic")}
        </div>

        {props.userType === 5 ? (
          <HasPermission permission="platform.delete">
            <div
              className={"alma-light-button"}
              onClick={async () => {
                // await detachPlatform();
                // setClinicOptionsSelected({
                //   id: null,
                //   label: $t("global.machines.detachfromdistributor"),
                //   value: null,
                // });
                setShowModalDetach(true);
              }}
            >
              {$t("global.machines.detachfromdistributor")}
            </div>
          </HasPermission>
        ) : null}

        {props.userType === 5 ? (
          <HasPermission permission="platform.delete">
            <div
              className={"alma-danger-button"}
              onClick={async () => {
                // await detachPlatform();
                setClinicOptionsSelected({
                  id: null,
                  label: $t("global.machines.detached"),
                  value: null,
                });
                setShowModal(true);
              }}
            >
              {$t("global.machines.detach")}
            </div>
          </HasPermission>
        ) : null}
      </div>

      <Modal
        content={renderModalContent()}
        onClose={async () => {
          setShowModal(false);
          await getClinicOptions();
        }}
        visible={showModal}
      />
      <Modal 
        content={renderModalDetachContent()}
        onClose={async () => {
          setShowModalDetach(false);
          // await getClinicOptions();
        }}
        visible={showModalDetach}
      />
    </div>
  );
};

export default ChangePlatformClinic;
